import Vue from "vue";
import App from "@/App";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import appSettings from "@/config";
// services
import apiEmployeeAccess, {
  buildApi
} from "@/services/employeeAccess/api/apiEmployeeAccess";
// import { getStoredUserName } from "@/services/user/userService";
// Axillary
// import { isEmpty } from "@/utils";
// store
import { INITIALIZE_STATES } from "@/store/solution/mutation-types";
// keycloak
import Keycloak from "keycloak-js";
import { getPayloadForPermissions } from "@/services/employeeAccess/login/loginService";

Vue.config.productionTip = false;
/**
 * URL of Runtime/Production Settings
 * @type {string}
 */
const urlRuntimeSettings = `/employee-access/runtimeSettings.json`; // this is to ensure that everytime when page is refreshed then runtimeSettings.json file should be fetched from correct URL
//
//if (!isDevelopment) {
fetch(urlRuntimeSettings)
  .then(response => {
    response
      .json()
      .then(runtimeSettings => {
        for (let key in runtimeSettings) {
          appSettings[key] = runtimeSettings[key];
        }
        CompleteInitialization();
      })
      .catch(e => {
        console.error("Parse Settings Failed", e);
        CompleteInitialization();
      });
  })
  .catch(e => {
    console.error("Load Settings Failed", e);
    CompleteInitialization();
  });
//} else {
//   CompleteInitialization();
// }

function CompleteInitialization() {
  buildApi();

  const keycloakOptions = {
    url: appSettings["identityProviderUrl"],
    realm: appSettings["identityProviderRealm"],
    clientId: appSettings["identityProviderClientId"],
    onLoad: "login-required"
  };

  const keycloak = new Keycloak(keycloakOptions);
  keycloak
    .init({ onLoad: keycloakOptions.onLoad })
    .then(async auth => {
      if (auth) {
        store.dispatch("user/initKeycloak", keycloak);
        store.dispatch("user/logIn");
        apiEmployeeAccess.updateAuthorization(keycloak);
        const payload = getPayloadForPermissions();
        await store
          .dispatch("user/setPermissions", payload)
          .catch(() => console.error("Failed to load permissions"));
      } else {
        console.info(`Not Authenticated`);
        window.location.reload();
      }

      new Vue({
        router,
        store,
        beforeCreate() {
          this.$store.commit(`solution/${INITIALIZE_STATES}`);
        },
        vuetify,
        render: h => h(App)
      }).$mount("#app");

      setInterval(() => {
        keycloak
          .updateToken(70)
          .then(refreshed => {
            if (refreshed) {
              apiEmployeeAccess.updateAuthorization(keycloak);
            } else {
              let secondsToExpire = Math.round(
                keycloak.tokenParsed.exp +
                  keycloak.timeSkew -
                  new Date().getTime() / 1000
              ).toString();
              console.warn(
                `Token not refreshed, valid for ${secondsToExpire} seconds`
              );
            }
          })
          .catch(() => {
            console.error("Failed to refresh token");
          });
      }, 60000);
    })
    .catch(() => {
      console.error("Authentication Failed");
    });
}
